// extracted by mini-css-extract-plugin
export var avatarContainer = "_g6-0";
export var avatarTypingWave = "_g6-i";
export var gray = "_g6-f";
export var green = "_g6-c";
export var icon = "_g6-9";
export var image = "_g6-1";
export var lg = "_g6-6";
export var md = "_g6-5";
export var presenceDot = "_g6-b";
export var red = "_g6-d";
export var sm = "_g6-4";
export var status = "_g6-a";
export var typingDot = "_g6-h";
export var typingPill = "_g6-g";
export var xl = "_g6-7";
export var xs = "_g6-3";
export var xxl = "_g6-8";
export var xxs = "_g6-2";
export var yellow = "_g6-e";